import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";

Vue.use(Vuex);

const getCookie = cname => {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
  }
  return "";
};

const state = {
  key: sessionStorage.getItem("needkey8") || getCookie("needkey8"),
  goodInfo: null
};

export default new Vuex.Store({
  state,
  actions,
  mutations
});